<template>
  <div>
    <van-pull-refresh v-model="refreshing"
      @refresh="onRefresh">
      <van-list>
        <van-empty v-if="twzblist.length == 0 && topList.length == 0" description="暂无内容" />
        <div class="recommend-box" v-if="topList.length !== 0||twzblist.length !== 0">
            <div
              v-for="(item, index) in topList"
              :key="item.data.messageid"
              class="text item">
              <div
                class="text-msg twzb-msg"
                style="border-bottom: 1px solid #dce2ea;">
                <div class="tezb-header" style="display: flex;align-items: center;margin-bottom: 10px;">
                  <div class="avatar-img">
                  <img :src="headImgs" alt="">
                </div>
                <div>
                  <div style="display:flex;">
                    <div class="recommend-user">{{item.data.name}}</div>
                    <div class="msgFlag">置顶</div>
                  </div>
                  <span class="createtime">
                    {{item.data.createtime}}
                  </span>
                </div>
                </div>
                <div class="zcrcalss" style="margin-bottom: 10px;">
                  <div
                    v-if="item.data.word != null"
                    class="twcontent twcontent-text">
                    {{ item.data.word }}
                  </div>
                  <div
                    v-if="item.data.message.twzbimagelist&&item.data.message.twzbimagelist.length>0"
                    class="twcontent">
                    <div
                      v-for="(res, index) in item.data.message.twzbimagelist"
                      :key="index">
                      <el-image :key="index"
                        style="width: 250px; height: 141px;background-color: whitesmoke;"
                        :src="res.file_path" fit="contain"></el-image>
                    </div>
                  </div>
                  <div
                    v-if="item.data.message.twzbimagelist&&item.data.message.twzbvideolist.length>0"
                    class="twcontent" >
                    <div
                      v-for="(dev, index) in item.data.message.twzbvideolist"
                      :key="index">
                      <video
                        width="250"
                        height="141"
                        :key="index"
                        controls>
                        <source
                          :src="dev.file_path"
                          type="video/mp4"/>
                      </video>
                    </div>
                  </div>
                </div>
              </div>  
            </div>
            <div
              v-for="(item, index) in twzblist"
              :key="index"
              class="text item">
              <div
                class="text-msg twzb-msg"
                style="border-bottom: 1px solid #dce2ea;">
                <div class="tezb-header" style="display: flex;align-items: center;margin-bottom: 10px;">
                  <div class="avatar-img">
                  <img :src="headImgs" alt="">
                </div>
                <div>
                  <div style="display:flex;">
                    <div class="recommend-user">{{item.data.name}}</div>
                  </div>
                  <span class="createtime">
                    {{item.data.createtime}}
                  </span>
                </div>
                </div>
                <div class="zcrcalss" style="margin-bottom: 10px;">
                  <div
                    v-if="item.data.word != null"
                    class="twcontent twcontent-text">
                    {{ item.data.word }}
                  </div>
                  <div
                    v-if="item.data.message.twzbimagelist&&item.data.message.twzbimagelist.length>0"
                    class="twcontent">
                    <div
                      v-for="(res, index) in item.data.message.twzbimagelist"
                      :key="index">
                      <el-image
                        style="width: 250px; height: 141px;background-color: whitesmoke;"
                        :src="res.file_path" fit="contain"></el-image>
                    </div>
                  </div>
                  <div
                    v-if="item.data.message.twzbimagelist&&item.data.message.twzbvideolist.length>0"
                    class="twcontent" >
                    <div
                      v-for="(dev, index) in item.data.message.twzbvideolist"
                      :key="index">
                      <video
                        width="250"
                        height="141"
                        controls>
                        <source
                          :src="dev.file_path"
                          type="video/mp4"/>
                      </video>
                    </div>
                  </div>
                </div>
              </div>  
            </div>  
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import axios from "@/utils/file";
import { Toast } from 'vant';
import { opneLoginPane, liveHasLogin, getWxPay } from "@/utils/app";
import {
    mapState,
    mapMutations
  } from "vuex";
export default {
  data () {
    return {
      headImgs:require('@/assets/img/default-header.png'),
      twzblist: [],
      topList:[],
      loading: false,
      finished: false,
      refreshing: false,
      uuid:'',
      info: {
        origin: 'web',
        nickname:'游客',
        id:'游客'+Math.round(Math.random()*1000),
        headimgurl: require('@/assets/img/default-header.png'),
      },
      sendtwzbobj:{},
      ws:null,
    };
  },
  props: {
    userinfo: {
      default: () => {
        return {};
      },
      required: true,
    },
  },
  // beforeDestroy () {
  //   if(this.$setWs.ws){
  //     console.log('页面关闭前')
  //     this.$setWs.ws.close()
  //   }
  // },
  computed: {
    ...mapState(["config", "inWX", "giftbtn", "IOS","Android"]),
    getWsMsg() {
      //在核心代码接收到的服务端信息存储到vuex的属性
        return this.$store.state.webSocketMsg
    }
  },
  created () {
    if (JSON.stringify(this.userinfo)!=="{}") {
      this.info = this.userinfo
    }
    this.activityId=this.$route.query.id
    // this.socketOpen('live',this.activityId,this.info)
  },
  destroyed () {
    console.log('离开页面tw');
    if(this.$setWs.ws){
      this.$setWs.ws.close()
    }
  },
  watch: {
    userinfo(newData){
      this.info = newData
    },
    getWsMsg(data, val) {
      if (data!=='{}') {
        this.messageData = JSON.parse(data)
        this.twzblist=this.messageData.questionList
        this.topList=this.messageData.topList
        this.giftList=this.messageData.giftList
        this.tipsList=this.messageData.tipsList
      }
    }
  },
  methods: {
    // 请求全部信息
    getDetall(type) {
      var a = {
          seq:this.uuid,
          type:type,
          data:{
            type: "getall",
            liveId: this.activityId,
            pagesize:10,
            offset:0,
          }
        };
      this.$setWs.ws.send(JSON.stringify(a));
    },
    // 建立websocket连接
    // type:网页通知message、活动直播-评论聊天chat、活动直播-互动问答qa、活动直播-图文直播live
    // 来源:手机分享页:wechat; 网页预览:web; 后台运营:admin; App:app;
    // 名称:网页:游客+时间戳; 后台:主持人; app:APP账户昵称; 微信:微信昵称;
    socketOpen (type,websocketId,userinfo) {
      if (JSON.stringify(this.userinfo)!=="{}") {
        var origin=userinfo.origin
        var userName=userinfo.nickname
      } else{
        var origin=this.inWX?'wechat':(this.IOS||this.Android)?'app':'web'
        var userName=this.info.nickname
      }
      var device = 1
      let wsServer=''
      if (process.env.NODE_ENV == 'production') {
        var num = process.env.VUE_APP_SCOKET.indexOf('https://')
        var protocol = process.env.VUE_APP_SCOKET.indexOf('https')!==-1 ? 'wss' : 'ws'
        var str = process.env.VUE_APP_SCOKET.substr(num+8)
        wsServer = `${protocol}://${str}websocket/${type}-${websocketId}-${origin}-${userName}-${device}`
      } else {
        wsServer = `${location.protocol === 'http:' ? 'ws' : 'wss'}://${location.host}/websocket/${type}-${websocketId}-${origin}-${userName}-${device}`
      }
      this.$setWs.initWebSocket(wsServer) // 调用全局定义socket,传入链接
      setTimeout(() => {
        axios.get(this.$api.getUuidSer).then(({ data }) => {
              if (data.status == 0) {
                this.uuid = data.data;
                this.getDetall(type)
              }
            })
      }, 500);
    },

    handleClickRecommendItem (item) {
      this.$emit('handleClickItem', item)
    },
    onLoad () {
      setTimeout(() => {
        if (this.refreshing) {
          this.twzblist = [];
          this.refreshing = false;
        }

        for (let i = 0; i < 10; i++) {
          let item = {
            title: '关于元旦活动问题关于元旦活动问题',
            time: '2021-10-15 12:00:00',
            img: 'https://t7.baidu.com/it/u=852388090,130270862&fm=193&f=GIF'
          }
          this.list.push(item);
        }
        this.loading = false;

        if (this.list.length >= 40) {
          this.finished = true;
        }
      }, 1000);
    },
    onRefresh () {
      this.refreshing = true
      setTimeout(() => {
        Toast('刷新成功');
        this.refreshing = false;
      }, 1000);
    }
  },
}
</script>
<style>
.twcontent .el-image img{
  height: 100% !important;
  
}
</style>
<style scoped>
.twcontent-text{
  font-size: 16px;
  color: #333333;
  line-height: 25px;
  margin-bottom: 10px;
  word-wrap: break-word;
  padding-left: 48px;
}
.recommend-box {
  padding: 0px 15px;
  box-sizing: border-box;
  width: 100%;
}
.twzb-msg{
  padding: 10px 0px;
}
.recommend-item {
  width: 100%;
  padding: 12px 0;
  border-bottom: 1px solid #f7f7f7;
}
.recommend-title {
  color: #333;
  font-size: 16px;
  font-weight: 600;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.avatar-img{
  width: 34px;
  height: 34px;
  /* background: #DFC8C8; */
  border-radius: 15px;
  margin-right: 15px;
}
.avatar-img img{
  width: 100%;
  height: 100%;
  display: block;
  border-radius: 15px;
}
.user-name{
  font-size: 12px;
  /* font-weight: 500; */
  color: #333333;
}
.createtime{
font-size: 12px;
font-weight: 500;
color: #999999;
display: block;
margin-top: 5px;
}
.msgFlag {
  background: #F0963A;
  border-radius: 2px;
  color: #fff;
  font-size: 9px;
  font-weight: Regular;
  padding: 2px 6px;
  margin-left: 6px;
  display: inline;
}
.recommend-user {
  color: #333333;
  font-size: 14px;
  font-weight: 700;
}
</style>